import {
    parkingAnalysis
} from './modules/parkingAnalysis'
import {
    roadsideRecord
} from './modules/roadsideRecord'
const FinanceLayOut = () => import( /*webpackChunkName:'finance'*/ '@/page/finance/financeLayOut.vue')
export const finance = {
    path: '/finance',
    name: '财务中心',
    component: FinanceLayOut,
    redirect: '/main/finance/financeReport',
    children: [
        parkingAnalysis, 
        roadsideRecord
    ]

}